module.exports = __webpack_public_path__ + "img/pr-5.eeb88743.png";